/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPredictionRequest
 */
export interface OrderPredictionRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderPredictionRequest
     */
    storeId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPredictionRequest
     */
    supplierIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof OrderPredictionRequest
     */
    deliveryDate?: Date;
    /**
     * Last date of historical data used for prediction
     * @type {Date}
     * @memberof OrderPredictionRequest
     */
    historyEndDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPredictionRequest
     */
    skuIds?: Array<string>;
}

/**
 * Check if a given object implements the OrderPredictionRequest interface.
 */
// @ts-ignore
export function instanceOfOrderPredictionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function OrderPredictionRequestFromJSON(json: any): OrderPredictionRequest {
    return OrderPredictionRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderPredictionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPredictionRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeId': !exists(json, 'store_id') ? undefined : json['store_id'],
        'supplierIds': !exists(json, 'supplier_ids') ? undefined : json['supplier_ids'],
        'deliveryDate': !exists(json, 'delivery_date') ? undefined : (new Date(json['delivery_date'])),
        'historyEndDate': !exists(json, 'history_end_date') ? undefined : (new Date(json['history_end_date'])),
        'skuIds': !exists(json, 'sku_ids') ? undefined : json['sku_ids'],
    };
}

// @ts-ignore
export function OrderPredictionRequestToJSON(value?: OrderPredictionRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'store_id': value.storeId,
        'supplier_ids': value.supplierIds,
        'delivery_date': value.deliveryDate === undefined ? undefined : (value.deliveryDate.toISOString()),
        'history_end_date': value.historyEndDate === undefined ? undefined : (value.historyEndDate.toISOString()),
        'sku_ids': value.skuIds,
    };
}

